require.config({
    baseUrl : (( typeof JSConst === 'object') ? JSConst.config.absRefPrefix : '/') + 'src/js'
});
require(['default/config'], function() {
    // @formatter:off
    require([
        'jquery',
        'mmc.libs.namespace',
        'mmc.libs.TrackingHelper',
        'partials/models/FormModel',
        'partials/views/FormView',
        'partials/views/TermsView',
        'partials/views/ThxPageView',
        'partials/router/AppRouter',
        'partials/views/rehabil/LocationMap',
        'partials/views/rehabil/Accordion',
        'mmc.libs.documentDomain',
        //'mmc.libs.iFrameResizer'
    ], function(
        $,
        namespace,
        TrackingHelper,
        FormModel,
        FormView,
        TermsView,
        ThxPageView,
        AppRouter,
        LocationMap,
        Accordion
    ) {
    // @formatter:on

    var trackingHelper,
        formModel,
        formView,
        termsView,
        thxPageView,
        appRouter;

        /*
         * init trackinghelper
         */
        (function() {
            var pageName;
            try {
                pageName = parent.dataLayer[0].pageNameVirtual;
            } catch(e) {
                pageName = '';
            }
            var trackingHelperConfig = {
                clean : true,

                pageName : ((JSConst.config.tracking.gtm.pageName.length > 0) ? JSConst.config.tracking.gtm.pageName : pageName),
                trackingCategory : 'Campaigns',
                trackingAction : JSConst.config.tracking.gtm.action,

                // To deactivate tracking for a specific tracking-engine set the function : null
                trackingMethods : {
                    //trackGAJS : null,
                    trackAnalyticsJS : null,
                    trackOmniture : null,
                    trackGenericGTM : null
                }
            };

            new LocationMap('.map svg', '.special-list');
            new Accordion('.accordion-wrap');

            $('.nav-burger').on('click', function(e) {
                $(e.currentTarget).parent('.main-nav').toggleClass('is-open');
            })

            $('label[for^=radio-]').on('click', function(e) {
                if($(window).height() < $(e.currentTarget.control).offset().top) {
                    $('html, body').stop().animate({scrollTop: $(e.currentTarget.control).offset().top});
                }
            });

            trackingHelper = new TrackingHelper(trackingHelperConfig);

            formModel = new FormModel({
            url : 'participation/'
        });


        formView = new FormView({
            name : 'form',
            templateString : $('.module-form--templates .template--form').html() || '',
            model : formModel
        });

        formView.on('onSubmit', function($formWrap) {
        });

        formView.on('onBeforeSend', function($formWrap, sendFieldsObj) {
            window.scrollTo(0, $('#win-form').offset().top);
            // to prevent form submission (e.g. after custom validation) throw string (which will be shown as error message):
            // throw 'custom validation error message';
            if (sendFieldsObj['newsletter'] === '1') {
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : 'newsletter_checked'
                });
            }
            if (sendFieldsObj['club'] === '1') {
                trackingHelper.track({
                    type : 'trackNOPV',
                    name : 'club_checked'
                });
            }
        });

        formView.on('onSuccessSend', function(data) {
        });

        termsView = new TermsView({
            name : 'terms',
            templateString : $('.module-form--templates .template--terms').html() || ''
        });

        thxPageView = new ThxPageView({
            name : 'thanks',
            templateString : $('.module-form--templates .template--thx-page').html() || ''
        });

        thxPageView.on('show', function(){
            trackingHelper.track('pageview', 'sweepstake-form-newsletter-thx-page');
        });


        appRouter = new AppRouter({
            defaultView : formView,
            views : [formView, termsView, thxPageView]
        });

        /*
         * create namespace and expose objects
         */
        namespace('MMCLIBS');
        MMCLIBS.trackingHelper = trackingHelper;
        MMCLIBS.formModel = formModel;
        MMCLIBS.formView = formView;
        MMCLIBS.termsView = termsView;
        MMCLIBS.thxPageView = thxPageView;
        MMCLIBS.appRouter = appRouter;

        /*
         * start routing
         */
        Backbone.history.start();

        })();
    });
});

define("default/master", function(){});

